module.exports = __webpack_public_path__ + "static/assets/6bdca129dbfc70788ba853dc2ca47f74.svg";